var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupDisplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 35",
    clipPath: "url(#clip0_45_1432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 145"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1257",
    x: 3,
    y: 2,
    width: 6,
    height: 6,
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1259",
    x: 1,
    y: 9,
    width: 6,
    height: 6,
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1258",
    x: 8.5,
    y: 7.5,
    width: 6,
    height: 6,
    rx: 3,
    stroke: "#626262",
    strokeDasharray: "1 0.5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_1432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupDisplay);
export default __webpack_public_path__ + "static/media/group-display.338d867f5a8a6e5ae2b07db3805cbe7c.svg";
export { ForwardRef as ReactComponent };